import { FC, useCallback } from 'react'
import { INTERNAL_ENTRY_URL } from 'tangle-shared'
import { useNativeHistory } from 'helpers/hookHelpers'

export const NavigationBack: FC = (props) => {
  const { children } = props
  const { history, hasHistory } = useNativeHistory()

  const onGoBack = useCallback(() => {
    if (hasHistory) {
      history.goBack()
    } else {
      history.push(INTERNAL_ENTRY_URL)
    }
  }, [hasHistory, history])

  return (
    <a onClick={ onGoBack }>
      { children }
    </a>
  )
}
